import React from 'react';
import styled from '@emotion/styled';
import { mqMin } from 'utils/responsive';
import { TopHeader } from 'ui/components/panes/Header/TopHeader';
import { TopFooter } from 'ui/components/panes/Footer/TopFooter';

const Container = styled.div`
    width: 87.674%;
    max-width: 1000px;
    margin: 60px auto;
    color: #333;
    line-height: 1.8;

    ${mqMin('NARROW')} {
        width: 92.014%;
    }
`;

const Title = styled.h2`
    font-size: 1.875rem;
    font-weight: bold;
    margin-bottom: 40px;
    border-left: 5px solid var(--blue);
    padding-left: 15px;
`;

const Table = styled.table`
    width: 100%;
    border-collapse: collapse;

    td {
        padding: 12px 10px;
        vertical-align: top;
        border-bottom: 1px solid #ddd;
    }

    td:first-of-type {
        width: 140px;
        font-weight: bold;
        color: #555;
    }
`;

export const CompanyProfile = () => {
    return (
        <>
            <TopHeader />
            <Container>
                <Title>会社概要</Title>
                <Table>
                    <tbody>
                        <tr>
                            <td>会社名</td>
                            <td>株式会社Sirbe</td>
                        </tr>
                        <tr>
                            <td>設立</td>
                            <td>2023年11月</td>
                        </tr>
                        <tr>
                            <td>事業所</td>
                            <td>東京都港区芝５－３６－４ 札ノ辻スクエア９階</td>
                        </tr>
                        <tr>
                            <td>事業内容</td>
                            <td>M&A仲介会社マッチングプラットフォーム「MAny」の企画・開発・運用</td>
                        </tr>
                        <tr>
                            <td>代表者</td>
                            <td>杉澤侑樹</td>
                        </tr>
                        <tr>
                            <td>お問い合わせ先</td>
                            <td>
                                <a href="mailto:info@ma-many.jp">info@ma-many.jp</a>
                            </td>
                        </tr>
                    </tbody>
                </Table>
            </Container>
            <TopFooter />
        </>
    );
};
